import type { BookedFlightItineraryWithDepartureTime } from "@b2bportal/air-booking-api";
import { Kind } from "@b2bportal/air-booking-api";

/**
 * Checks if a flight itinerary has travel insurance ancillary
 */
export const hasFlightInsurance = (
  itinerary: BookedFlightItineraryWithDepartureTime | null | undefined
): boolean => {
  return (
    itinerary?.bookedItinerary?.sellingPricing?.totalPricing?.ancillaries?.some(
      (a) => a.kind === Kind.Insurance
    ) ?? false
  );
};
